var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85037 8.93149L0.706055 4.76206L1.32255 4.14556L4.49575 7.31876L4.8493 7.67232L5.20285 7.31876L11.8185 0.703125L12.4555 1.32633L4.85037 8.93149Z",
    fill: "url(#paint0_linear_45_2105)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84928 9.63978L0 4.76111L1.32253 3.43858L4.84928 6.96533L11.8146 0L13.1665 1.32253L4.84928 9.63978Z",
    fill: "url(#paint1_linear_45_2105)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_2105",
    x1: 0.706055,
    y1: 4.81731,
    x2: 12.4555,
    y2: 4.81731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45_2105",
    x1: 0,
    y1: 4.81989,
    x2: 13.1665,
    y2: 4.81989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3489c2850b225a0e548d1bc895556529.svg";
export { ForwardRef as ReactComponent };